export type ResamplingOrigin = 'applied' | 'approximated';

export function resamplingRefusal(origin: ResamplingOrigin): string {
    return origin === 'approximated'
        ? "This image was rebuilt here from a registration's sampled " +
              'displacement field. It approximates the transform rather than ' +
              'reproducing it, and its intensities are an interpolation of a ' +
              'scan acquired elsewhere, so a receiving system would take it ' +
              'for a study of this patient and could plan on it.'
        : "This image was resampled onto another image's geometry. Its " +
              'intensities are an interpolation of a scan acquired elsewhere, ' +
              'so a receiving system would take it for a study of this ' +
              'patient and could plan on it.';
}

export function resamplingLabelIds(origin: ResamplingOrigin): {
    label: string;
    hint: string;
} {
    return origin === 'approximated'
        ? { label: 'image.approximated', hint: 'image.approximated.hint' }
        : { label: 'image.resampled', hint: 'image.resampled.hint' };
}

interface ResampledImage {
    readonly resamplingOrigin?: ResamplingOrigin;
    readonly frameOfReferenceUid: string;
    wasResampledBy(registrationSopUid: string): boolean;
}

// The worker's scan of this deformation is the transform it applied, so it wins; another run's scan does not.
export function hasWorkerResampledImage(
    images: ReadonlyArray<ResampledImage>,
    frameOfReferenceUid: string,
    registrationSopUid: string
): boolean {
    return images.some(
        (image) =>
            image.resamplingOrigin === 'applied' &&
            image.frameOfReferenceUid === frameOfReferenceUid &&
            image.wasResampledBy(registrationSopUid)
    );
}
